// will export a function so you can import it in other programs

export const Questions = [
  { id: '1', text: 'Name', type: 'text' },
  { id: '2', text: 'Date of Birth', type: 'text' },
  { id: '4', text: 'Primary diagnosis', type: 'text' },
  { id: '5', text: 'Oncologist', type: 'checkbox' },
  { id: '6', text: 'Name of treating hospital', type: 'text' },
  { id: '7', text: 'Last follow-up appointment', type: 'text' },
  { id: '8', text: 'GP/Family Physician', type: 'text' },
  { id: '9', text: 'Treatment', type: 'checkbox' },
  { id: '10', text: 'Level of Education', type: 'dropdown' },
  { id: '11', text: 'Marital status', type: 'dropdown' },
  { id: '12', text: 'MRN', type: 'text' },
  { id: '13', text: 'Gender', type: 'radio' },
  { id: '14', text: 'Age of diagnosis', type: 'text' },
  { id: '15', text: 'Level of risk', type: 'radio' },
  { id: '16', text: 'Age of parents', type: 'text' },
  { id: '17', text: 'Last seen by doctor', type: 'text' },
  { id: '18', text: 'Years since active treatment', type: 'text' },
  { id: '19', text: 'Place of residence', type: 'text' },
  { id: '20', text: 'Employment status', type: 'dropdown' },
  { id: '21', text: 'How are you?', type: 'text' },
  { id: '22', text: 'What are you up to currently?', type: 'text' },
  { id: '23', text: 'How is your family?', type: 'text' },
  { id: '24', text: 'Are you living at home? Children?', type: 'text' },
  { id: '25', text: 'Did your parents ever pass on information to you about your cancer or treatment?', type: 'radio' },
  { id: '26', text: 'Can you remember when you were you last seen at the hospital or long term follow-up clinic or by your oncologist?', type: 'dropdown' },
  { id: '27', text: 'If yes, were you advised to return?', type: 'radio' },
  { id: '28', text: 'If yes, why didn\'t you return?', type: 'text' },
  { id: '29', text: 'Have you received a treatment summary/passport etc?', type: 'radio' },
  { id: '30', text: 'If no, would you like a summary?', type: 'radio' },
  { id: '31', text: 'How has your health been since we saw you last at the hospital?', type: 'text' },
  { id: '32', text: 'Have you been to the GP for any illnesses or concerns in the last 2 years?', type: 'radio' },
  { id: '33', text: 'Are you seeing any other HCP for any health issues?', type: 'text' },
  { id: '34', text: 'If yes, do you think any of these problems are related to your previous cancer diagnosis and/or treatment?', type: 'radio' },
  { id: '35', text: 'Are you on any regular medication?', type: 'radio' },
  { id: '36', text: 'If yes, list meds and dosages', type: 'text' },
  { id: '37', text: 'Are you taking any regular herbal supplements?', type: 'radio' },
  { id: '38', text: 'Were you ever told that your cancer has returned?', type: 'radio' },
  { id: '39', text: 'If yes, did you receive additional therapy?', type: 'radio' },
  { id: '40', text: 'Have you ever been diagnosed with a second cancer/ cancer that is different to the first one you had?', type: 'radio' },
  { id: '41', text: 'If yes, did you receive additional therapy?', type: 'radio' },
  { id: '42', text: 'Do you know what a genetic condition is?', type: 'radio' },
  { id: '43', text: 'Are you aware of any genetic condition affecting you or your family?', type: 'radio' },
  { id: '44', text: 'If yes, has anyone mentioned this may affect your risk of another cancer?', type: 'radio' },
  { id: '45', text: 'Do you have any relatives who were diagnosed with cancer under the age of 70 years?', type: 'radio' },
  { id: '46', text: 'If yes, what type of cancer, age of diagnosis and relation are they to you?', type: 'text' },
  { id: '47', text: 'Can you remember the names of any of the chemotherapy you received?', type: 'checkbox' },
  { id: '48', text: 'Have you ever had a bone marrow /stem cell transplant?', type: 'radio' },
  { id: '49', text: 'If yes, do you remember where your marrow came from?', type: 'radio' },
  { id: '50', text: 'If yes, was it your own marrow or from a relative like a brother or sister a cord blood or from an anonymous unrelated donor?', type: 'radio' },
  { id: '51', text: 'Have you had radiation treatment or radiotherapy?', type: 'radio' },
  { id: '52', text: 'If yes, was it to one area of your body or to the whole body?', type: 'text' },
  { id: '53', text: 'If yes, do you know how old were you when you had your radiotherapy?', type: 'radio' },
  { id: '54', text: 'Have you had surgery?', type: 'radio' },
  { id: '55', text: 'If yes, what type of surgery and where did you have the surgery?', type: 'text' },
  { id: '56', text: 'Do you believe you have ever experienced any physical or emotional late complications from your cancer(s) or their treatment(s)?', type: 'radio' },
  { id: '57', text: 'Since finishing treatment, do you think you have as much energy as your friends and family?', type: 'radio' },
  { id: '58', text: 'Do you need to take time off school or work because you are tired/fatigued?', type: 'radio' },
  { id: '59', text: 'If yes, is it interfering with your normal activities, school /work?', type: 'radio' },
  { id: '60', text: 'Do you socialise with friends and family?', type: 'radio' },
  { id: '61', text: 'Do you smoke?', type: 'radio' },
  { id: '62', text: 'Do you take recreational drugs?', type: 'radio' },
  { id: '63', text: 'Do you regularly drink alcohol?', type: 'radio' },
  { id: '64', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '65', text: 'If yes to any above, establish if this is currently an issue', type: 'text' },
  { id: '66', text: 'Do you have any problems with your eyesight?', type: 'radio' },
  { id: '67', text: 'Do you wear glasses?', type: 'radio' },
  { id: '68', text: 'If yes, do you know why?', type: 'radio' },
  { id: '69', text: 'Have you ever been told you have cataracts?', type: 'radio' },
  { id: '70', text: 'If yes, have they ever caused you problems?', type: 'radio' },
  { id: '71', text: 'Do you have to use eye drops for dry eyes?', type: 'radio' },
  { id: '72', text: 'Do you have any other visual problems?', type: 'radio' },
  { id: '73', text: 'Has anyone ever told you that you have any of the following?', type: 'checkbox' },
  { id: '74', text: 'Do you have any trouble with your hearing?', type: 'radio' },
  { id: '75', text: 'Do you or have you every worn hearing aids?', type: 'radio' },
  { id: '76', text: 'Have you had your hearing tested?', type: 'radio' },
  { id: '77', text: 'If yes, do you know why?', type: 'text' },
  { id: '78', text: 'Do you suffer from tinnitus (ringing in the ears)?', type: 'radio' },
  { id: '79', text: 'When did it start?', type: 'text' },
  { id: '80', text: 'How much of a problem is it for you?', type: 'text' },
  { id: '81', text: 'Do you see a HCP for it?', type: 'radio' },
  { id: '82', text: 'Do you have any problems with vertigo or balance (balance problems must be differentiated from cerebellar problems)', type: 'radio' },
  { id: '83', text: 'Do you have any other problems related to your ears?', type: 'radio' },
  { id: '84', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '85', text: 'Do you see the dentist regularly?', type: 'radio' },
  { id: '86', text: 'If no, when was the last time you saw them?', type: 'text' },
  { id: '87', text: 'Do you see the same dentist?', type: 'radio' },
  { id: '88', text: 'Does the dentist have any concerns about your teeth?', type: 'radio' },
  { id: '89', text: 'Does the dentist have any concerns about your teeth?', type: 'text' },
  { id: '90', text: 'Have you had any major work done to your teeth?', type: 'radio' },
  { id: '91', text: 'Have you had any major work done to your teeth?', type: 'text' },
  { id: '92', text: 'Do you brush/floss your teeth regularly?', type: 'radio' },
  { id: '93', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '94', text: 'Height (cm)', type: 'text' },
  { id: '95', text: 'Weight (kg)', type: 'text' },
  { id: '96', text: 'Waist circumference (cm)', type: 'text' },
  { id: '97', text: 'Do you have diabetes?', type: 'radio' },
  { id: '98', text: 'How old were you when you were diagnosed?', type: 'text' },
  { id: '99', text: 'Are you on medication?', type: 'radio' },
  { id: '100', text: 'Does anyone else in your family have diabetes?', type: 'radio' },
  { id: '101', text: 'Does anyone else in your family have diabetes?', type: 'text' },
  { id: '102', text: 'Have you ever had any problems with your thyroid?', type: 'checkbox' },
  { id: '103', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '104', text: 'Do you have any problems urinating?', type: 'radio' },
  { id: '105', text: 'Have you ever been told there was a problem with your kidney?', type: 'radio' },
  { id: '106', text: 'Have you ever been told that there is a problem with your bladder?', type: 'radio' },
  { id: '107', text: 'Do you experience urinary urgency?', type: 'radio' },
  { id: '108', text: 'Do you suffer from UTIs or cystitis regularly?', type: 'radio' },
  { id: '109', text: 'Have you received treatment for them?', type: 'radio' },
  { id: '110', text: 'Do you have blood in your urine?', type: 'radio' },
  { id: '111', text: 'Any problems with incontinence (leakage)?', type: 'radio' },
  { id: '112', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '113', text: 'Do you recall ever having a discussion about fertility preservation?', type: 'radio' },
  { id: '114', text: 'Did you store eggs?', type: 'radio' },
  { id: '115', text: 'Do you have a regular period?', type: 'radio' },
  { id: '116', text: 'How old were you when you got your 1st period?', type: 'text' },
  { id: '117', text: 'How frequently? How long does it last?', type: 'text' },
  { id: '118', text: 'Do you have any pain associated with your period?', type: 'text' },
  { id: '119', text: 'Do you take regular pain relief for this problem? If yes, what type?', type: 'text' },
  { id: '120', text: 'Do you take oral contraception/the pill?', type: 'radio' },
  { id: '121', text: 'Do you have any children?', type: 'radio' },
  { id: '122', text: 'How many children do you have?', type: 'radio' },
  { id: '123', text: 'Did  you have any trouble falling pregnant?', type: 'radio' },
  { id: '124', text: 'Have you ever been told by a GP/oncologist or nurse that you might have problems with your fertility/having children?  ', type: 'radio' },
  { id: '125', text: 'Can you remember what you were told?', type: 'text' },
  { id: '126', text: 'Do you have any concerns about having children in the future?', type: 'radio' },
  { id: '127', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '128', text: 'Do you recall ever having a discussion about fertility preservation?', type: 'radio' },
  { id: '129', text: 'Did you store sperm?', type: 'radio' },
  { id: '130', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '131', text: 'Have you ever been diagnosed with any heart problems?', type: 'radio' },
  { id: '132', text: 'Did you receive any treatment for this?', type: 'radio' },
  { id: '133', text: 'Have you had an echocardiogram?', type: 'radio' },
  { id: '134', text: 'Do you know what the result was?', type: 'text' },
  { id: '135', text: 'Have you had any episodes of chest pain?', type: 'radio' },
  { id: '136', text: 'When does it happen?', type: 'text' },
  { id: '137', text: 'Do you still experience this?', type: 'radio' },
  { id: '138', text: 'Have you ever been told you should see a doctor for your heart because of some of the chemotherapy or radiotherapy you received?   ', type: 'radio' },
  { id: '139', text: 'Have you ever had a blood clot or Deep Venous Thrombosis (DVT)?', type: 'radio' },
  { id: '140', text: 'Do you have high blood pressure or are you on medication for high blood pressure?', type: 'radio' },
  { id: '141', text: 'Does anyone in your family suffer from high blood pressure?', type: 'radio' },
  { id: '142', text: 'List family member(s)', type: 'text' },
  { id: '143', text: 'Have you ever been told you have an irregular heartbeat?', type: 'radio' },
  { id: '144', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '145', text: 'Have you had any problems with your breathing/lungs since completing treatment?', type: 'radio' },
  { id: '146', text: 'Shortness of breath?', type: 'radio' },
  { id: '147', text: 'Poor exercise tolerance?', type: 'radio' },
  { id: '148', text: 'Tightness in your chest?', type: 'radio' },
  { id: '149', text: 'Have you been to the GP about this?', type: 'radio' },
  { id: '150', text: 'What was the outcome?', type: 'text' },
  { id: '151', text: 'Do you have asthma?', type: 'radio' },
  { id: '152', text: 'Do you regularly get colds or flus?', type: 'radio' },
  { id: '153', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '154', text: 'Do you have any problems with your stomach? (e.g. pain, tenderness, constipation etc.)', type: 'radio' },
  { id: '155', text: 'Please select the stomach problems you have experienced', type: 'checkbox' },
  { id: '156', text: 'Has any of this been investigated?', type: 'radio' },
  { id: '157', text: 'How often does it happen?', type: 'text' },
  { id: '158', text: 'How often does it happen?', type: 'text' },
  { id: '159', text: 'How often does it happen?', type: 'text' },
  { id: '160', text: 'How often does it happen?', type: 'text' },
  { id: '161', text: 'How often does it happen?', type: 'text' },
  { id: '162', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '163', text: 'Do you have any problems with your joints or muscles?', type: 'radio' },
  { id: '164', text: 'Do you have any muscle or joint pain?', type: 'radio' },
  { id: '165', text: 'Do you think there is any part of your body that hasn’t grown as quickly as the rest?', type: 'radio' },
  { id: '166', text: 'Do you have any underdeveloped limbs?', type: 'radio' },
  { id: '167', text: 'Do you have any curvature of the spine?', type: 'radio' },
  { id: '168', text: 'Have you ever had any broken bones or fractures?', type: 'radio' },
  { id: '169', text: 'If yes, was it broken or fractured?', type: 'checkbox' },
  { id: '170', text: 'How did that happen?', type: 'text' },
  { id: '171', text: 'Can you remember the name of the fracture?', type: 'text' },
  { id: '172', text: 'Do you have any ongoing problems?', type: 'text' },
  { id: '173', text: 'Did you have surgery or plaster?', type: 'text' },
  { id: '174', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '175', text: 'Please specify site of Osteonecrosis (avascular necrosis – AVN)', type: 'text' },
  { id: '176', text: 'Please specify type and site of Amputation', type: 'text' },
  { id: '177', text: 'Please specify type of Functional and activity limitation', type: 'text' },
  { id: '178', text: 'Please specify site of Hypoplasia', type: 'text' },
  { id: '179', text: 'Please specify type and site of Limb salvage', type: 'text' },
  { id: '180', text: 'Has your doctor ever diagnosed you with problems related to your central nervous system?', type: 'radio' },
  { id: '181', text: 'Do you have any of the following?', type: 'checkbox' },
  { id: '182', text: 'How long have you experienced fitting (epilepsy)?', type: 'text' },
  { id: '183', text: 'How long have you experienced problems with your balance?', type: 'text' },
  { id: '184', text: 'How long have you experienced problems with swallowing?', type: 'text' },
  { id: '185', text: 'How long have you been taking your growth hormone?', type: 'text' },
  { id: '186', text: 'Have you noticed any sensations of pins and needles or tingling or numbness in your fingers or toes?', type: 'radio' },
  { id: '187', text: 'If yes, when does it occur (e.g. sleeping or random) and does it go away?', type: 'text' },
  { id: '188', text: 'Do you ever have any trouble doing up buttons or using a pen or pencil?', type: 'radio' },
  { id: '189', text: 'If yes, is it often or just occasionally?', type: 'text' },
  { id: '190', text: 'Do you have any concerns regarding your mobility or any part of your body’s function/movement?', type: 'radio' },
  { id: '191', text: 'If yes, do you have any problems going up the stairs?', type: 'radio' },
  { id: '192', text: 'Have you ever been told that you have peripheral neuropathy? ', type: 'radio' },
  { id: '193', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '194', text: 'Have you had any problems with your skin? ', type: 'radio' },
  { id: '195', text: 'Do you have many freckles or moles?', type: 'radio' },
  { id: '196', text: 'Do your nails grow? ', type: 'radio' },
  { id: '197', text: 'Do you have noticeably thin hair?', type: 'radio' },
  { id: '198', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '199', text: 'Have you experienced any of the following?', type: 'checkbox' },
  { id: '200', text: 'Please specify type of asplenia', type: 'radio' },
  { id: '201', text: 'Have you experienced any of the following?', type: 'checkbox' },
];

export const oncologistOptions = [
  { id: '1', display: 'Richard Cohn' },
  { id: '2', display: 'Darcy O\'Gormon-Hughes' },
  { id: '3', display: 'Marcus Vowels' },
  { id: '4', display: 'Glenn Marshall' },
  { id: '5', display: 'Tracey O\'Brien' },
  { id: '6', display: 'Antoinette Anazodo' },
  { id: '7', display: 'Draga Barbaric' },
  { id: '8', display: 'Susan Russell' },
  { id: '9', display: 'Toby Trahair' },
  { id: '10', display: 'David Ziegler' },
];

export const treatmentOptions = [
  { id: '1', display: 'Surgery' },
  { id: '2', display: 'Chemotherapy' },
  { id: '3', display: 'Radiotherapy' },
  { id: '4', display: 'Bone Marrow Transplant/Stem Cell Transplant' },
  { id: '5', display: 'Other' },
];

export const educationOptions = [
  { id: '1', display: 'Year 10 or below' },
  { id: '2', display: 'Year 12' },
  { id: '3', display: 'Apprenticeship' },
  { id: '4', display: 'Certificate/diploma' },
  { id: '5', display: 'University degree' },
  { id: '6', display: 'Post-graduate degree' },
];

export const maritalStatusOptions = [
  { id: '1', display: 'Never married or never de facto' },
  { id: '2', display: 'Currently married or de facto' },
  { id: '3', display: 'Separated/divorced/previous de facto' },
  { id: '4', display: 'Widowed' },
];

export const genderOptions = [
  { id: '1', display: 'Male' },
  { id: '2', display: 'Female' },
  { id: '3', display: 'Other' },
];

export const diagnosisRiskLevelOptions = [
  { id: '1', display: 'Standard' },
  { id: '2', display: 'Low' },
  { id: '3', display: 'Intermediate' },
  { id: '4', display: 'High' },
  { id: '5', display: 'Don\'t know' },
];

export const employmentOptions = [
  { id: '1', display: 'Full-time' },
  { id: '2', display: 'Part-time' },
  { id: '3', display: 'Casual' },
  { id: '4', display: 'Actively seeking work' },
  { id: '5', display: 'Not seeking work' },
  { id: '6', display: 'Retired' },
  { id: '7', display: 'Student' },
  { id: '8', display: 'Home duties' },
];

export const yesNoDKOptions = [
  { id: '1', display: 'Yes' },
  { id: '2', display: 'No' },
  { id: '3', display: 'Don\'t Know' },
];

export const yesNoOptions = [
  { id: '1', display: 'Yes' },
  { id: '2', display: 'No' },
];

export const chemotherapyOptions = [
  { id: '1', display: 'Anthracyclines' },
  { id: '2', display: 'Oxaliplatin' },
  { id: '3', display: 'Cisplatin' },
  { id: '4', display: 'Carboplatin' },
  { id: '5', display: 'Paclitaxel' },
  { id: '6', display: 'Docetaxel' },
  { id: '7', display: 'Cabazitaxel' },
  { id: '8', display: 'Vincristine' },
  { id: '9', display: 'Vinblastine' },
  { id: '10', display: 'Venorelbine' },
  { id: '11', display: 'Vinflunine' },
  { id: '12', display: 'Vindesine' },
  { id: '13', display: 'Thalidomide' },
  { id: '14', display: 'Bortezamib' },
  { id: '15', display: 'Ixabepilone' },
  { id: '16', display: 'Lenalidomide Pomalidomide' },
  { id: '17', display: 'Eribulin' },
  { id: '18', display: 'Bleomycin' },
  { id: '19', display: 'Etoposide' },
  { id: '20', display: 'Other' },
  { id: '21', display: 'Not applicable' },
  { id: '22', display: 'Don\'t Remember' },
];

export const marrowTransplantOptions = [
  { id: '1', display: 'Allogeneic' },
  { id: '2', display: 'Autologous' },
];

export const yesNoNAOptions = [
  { id: '1', display: 'Yes' },
  { id: '2', display: 'No' },
  { id: '3', display: 'Not Applicable' },
];

export const smokingOptions = [
  { id: '1', display: 'Never' },
  { id: '2', display: 'Ex-smoker' },
  { id: '3', display: 'Current smoker' },
];

export const recreationalDrugsUseOptions = [
  { id: '1', display: 'No, never' },
  { id: '2', display: 'Yes, used to' },
  { id: '3', display: 'Yes, currently' },
];

export const alcoholUseOptions = [
  { id: '1', display: 'Never/given up alcohol' },
  { id: '2', display: 'Only on special occasions' },
  { id: '3', display: 'Regularly' },
];

export const psychosocialProblemsOptions = [
  { id: '1', display: 'Anxiety' },
  { id: '2', display: 'Problems accessing healthcare and/or insurance?' },
  { id: '3', display: 'Access to NDIS?' },
  { id: '4', display: 'Are you able to live independently?' },
  { id: '5', display: 'Fatigue' },
  { id: '6', display: 'Psychosocial disability due to pain arthritis related?' },
  { id: '7', display: 'Behavioral problems, or changes in behaviour?' },
  { id: '8', display: 'Problems at school or university?' },
  { id: '9', display: 'Problems at work or finding work?' },
  { id: '10', display: 'Problems in your relationship/marriage?' },
  { id: '11', display: 'Suicidal ideation' },
  { id: '12', display: 'Post-traumatic stress' },
  { id: '13', display: 'Psychosocial disability due to pain' },
  { id: '14', display: 'Social withdrawal' },
  { id: '15', display: 'Social activities' },
  { id: '16', display: 'Psychosocial maladjustment' },
  { id: '17', display: 'Impaired quality of life' },
  { id: '18', display: 'Other' },
  { id: '19', display: 'Not applicable' },
  { id: '20', display: 'Don\'t Remember' },
];

export const glassesOptions = [
  { id: '1', display: 'Long-sighted' },
  { id: '2', display: 'Short-sighted' },
  { id: '3', display: 'Both' },
];

export const headNeckProblemsOptions = [
  { id: '1', display: 'Visual impairment (uncorrectable)' },
  { id: '2', display: 'Glaucoma' },
  { id: '3', display: 'Lacrimal duct atrophy' },
  { id: '4', display: 'Enophthalmos' },
  { id: '5', display: 'Optic Chiasm neuropathy' },
  { id: '6', display: 'Orbital hypoplasia' },
  { id: '7', display: 'Keratitis' },
  { id: '8', display: 'Xerophthalmia' },
  { id: '9', display: 'Chronic painful eye' },
  { id: '10', display: 'Ocular nerve palsy' },
  { id: '11', display: 'Gaze paresis' },
  { id: '12', display: 'Nystagmus' },
  { id: '13', display: 'Papilledema' },
  { id: '14', display: 'Optic atrophy' },
  { id: '15', display: 'Other' },
  { id: '16', display: 'Not applicable' },
  { id: '17', display: 'Don\'t Remember' },
];

export const earProblemsOptions = [
  { id: '1', display: 'Ear infections' },
  { id: '2', display: 'Eustachian tube dysfunction' },
  { id: '3', display: 'Otosclerosis' },
  { id: '4', display: 'Tympanosclerosis' },
  { id: '5', display: 'Other' },
  { id: '6', display: 'Not applicable' },
  { id: '7', display: 'Don\'t Remember' },
];

export const dentalProblemsOptions = [
  { id: '1', display: 'Dental abnormalities' },
  { id: '2', display: 'Enamel dysplasia' },
  { id: '3', display: 'Root thinning/shortening' },
  { id: '4', display: 'Tooth/root agenesis' },
  { id: '5', display: 'Microdontia' },
  { id: '6', display: 'Periodontal disease' },
  { id: '7', display: 'Tooth decay' },
  { id: '8', display: 'Malocclusion' },
  { id: '9', display: 'Xerostomia (salivary gland dysfunction)' },
  { id: '10', display: 'Osteoradionecrosis' },
  { id: '11', display: 'Temporomandibular joint dysfunction' },
  { id: '12', display: 'Other' },
  { id: '13', display: 'Not applicable' },
  { id: '14', display: 'Don\'t Remember' },
];

export const diabetesOptions = [
  { id: '1', display: 'No' },
  { id: '2', display: 'Yes, Type 1' },
  { id: '3', display: 'Yes, Type 2' },
  { id: '4', display: 'Don\'t Know' },
];

export const thyroidProblemsOptions = [
  { id: '1', display: 'Hypothyroidism' },
  { id: '2', display: 'Primary hypothyroidism (thyroid gland failure)' },
  { id: '3', display: 'Secondary (central) hypothyroidism (TR/TSH deficiency)' },
  { id: '4', display: 'Hyperthyroidism' },
  { id: '5', display: 'Thyroid nodule' },
  { id: '6', display: 'Not applicable' },
  { id: '7', display: 'Don\'t Remember' },
];

export const endocrineProblemsOptions = [
  { id: '1', display: 'Overweight (Age 2-20 yrs: BMI for age >85 - <95%ile; Age >20 yrs: BMI 25 to 29.9)' },
  { id: '2', display: 'Obesity (Age 2-20 yrs: BMI for age >95%ile; Age >20 yrs, BMI >30)' },
  { id: '3', display: 'Underweight (FTT)' },
  { id: '4', display: 'Insulin resistance' },
  { id: '5', display: 'Metabolic syndrome' },
  { id: '6', display: 'Precocious puberty' },
  { id: '7', display: 'Gonadal dysfunction/failure' },
  { id: '8', display: 'Gonadotropin deficiency (LH/FSH deficiency) [central gonadal failure]' },
  { id: '9', display: 'Gonadal dysfunction – testicular' },
  { id: '10', display: 'Gonadal dysfunction – ovarian' },
  { id: '11', display: 'Impaired glucose tolerance' },
  { id: '12', display: 'Gestational' },
  { id: '13', display: 'Dyslipidemia' },
  { id: '14', display: 'Adrenal insufficiency' },
  { id: '15', display: 'Primary adrenal insufficiency (adrenal gland failure)' },
  { id: '16', display: 'Secondary (central) adrenal insufficiency (ACTH deficiency)' },
  { id: '17', display: 'Hyperprolactinemia' },
  { id: '18', display: 'Growth deceleration' },
  { id: '19', display: 'Growth hormone deficiency' },
  { id: '20', display: 'Short stature (<5th percentile)' },
  { id: '21', display: 'Other' },
  { id: '22', display: 'Not applicable' },
  { id: '23', display: 'Don\'t Remember' },
];

export const urinaryProblemsOptions = [
  { id: '1', display: 'Hydronephrosis' },
  { id: '2', display: 'Hypertension' },
  { id: '3', display: 'Renal insufficiency' },
  { id: '4', display: 'Renal glomerular disorder' },
  { id: '5', display: 'Hyperfiltration' },
  { id: '6', display: 'Renal tubular disorder' },
  { id: '7', display: 'Hypophosphatemic rickets' },
  { id: '8', display: 'Renal Fanconi syndrome' },
  { id: '9', display: 'Renal tubular acidosis' },
  { id: '10', display: 'Vesicoureteral reflux' },
  { id: '11', display: 'Bladder fibrosis' },
  { id: '12', display: 'Urinary incontinence' },
  { id: '13', display: 'Reservoir calculi' },
  { id: '14', display: 'Dysfunctional voiding' },
  { id: '15', display: 'Hemorrhagic cystitis' },
  { id: '16', display: 'Proteinuria' },
  { id: '17', display: 'Chronic UTI' },
  { id: '18', display: 'Asymptomatic bacteriuria' },
  { id: '19', display: 'Neobladder perforation' },
  { id: '20', display: 'Urinary tract obstruction (due to retroperitoneal fibrosis)' },
  { id: '21', display: 'Other' },
  { id: '22', display: 'Not applicable' },
  { id: '23', display: 'Don\'t Remember' },
];

export const fReproductiveProblemsOptions = [
  { id: '1', display: 'Breast tissue hypoplasia' },
  { id: '2', display: 'Uterine vascular insufficiency' },
  { id: '3', display: 'Adverse pregnancy outcome' },
  { id: '4', display: 'Pregnancy complications' },
  { id: '5', display: 'Delivery complications' },
  { id: '6', display: 'Fetal malposition' },
  { id: '7', display: 'Low birthweight infant' },
  { id: '8', display: 'Spontaneous abortion' },
  { id: '9', display: 'Premature labor' },
  { id: '10', display: 'Neonatal death' },
  { id: '11', display: 'Gonadal dysfunction - ovarian' },
  { id: '12', display: 'Primary ovarian failure' },
  { id: '13', display: 'Delayed/arrested puberty' },
  { id: '14', display: 'Premature menopause' },
  { id: '15', display: 'Infertility' },
  { id: '16', display: 'Inability to conceive (despite normal ovarian function)' },
  { id: '17', display: 'Dyspareunia' },
  { id: '18', display: 'Symptomatic ovarian cysts' },
  { id: '19', display: 'Pelvic adhesions' },
  { id: '20', display: 'Psychosexual dysfunction' },
  { id: '21', display: 'Vaginal stenosis/fibrosi' },
  { id: '22', display: 'Other' },
  { id: '23', display: 'Not applicable' },
  { id: '24', display: 'Don\'t Remember' },
];

export const mReproductiveProblemsOptions = [
  { id: '1', display: 'Gonadal dysfunction - testicular (Germ cell failure, Azoospermia, Oligospermia, Infertility)' },
  { id: '2', display: 'Leydig cell failure (Hypodonadism testosterone deficiency, delayed/arrested puberty)' },
  { id: '3', display: 'Psychosexual dysfunction - male (erectile dysfunction, anejunction, retrograd ejaculation, Hydrocele)' },
  { id: '4', display: 'Other' },
  { id: '5', display: 'Not applicable' },
  { id: '6', display: 'Don\'t Remember' },
];

export const cardiovascularProblemsOptions = [
  { id: '1', display: 'Arrhythmia' },
  { id: '2', display: 'Atherosclerotic heart disease' },
  { id: '3', display: 'Cardiomyopathy' },
  { id: '4', display: 'Congestive heart failure' },
  { id: '5', display: 'Myocardial infarction' },
  { id: '6', display: 'Pericardial fibrosis' },
  { id: '7', display: 'Pericarditis' },
  { id: '8', display: 'Subclinical left ventricular dysfunction' },
  { id: '9', display: 'Displayvular disease' },
  { id: '10', display: 'Carotid artery disease' },
  { id: '11', display: 'Subclavian artery disease' },
  { id: '12', display: 'Vasospastic attacks (Raynaud’s phenomenon)' },
  { id: '13', display: 'Other' },
  { id: '14', display: 'Not applicable' },
  { id: '15', display: 'Don\'t Remember' },
];

export const pulmonaryProblemsOptions = [
  { id: '1', display: 'Bronchiolitis obliterans' },
  { id: '2', display: 'Interstitial pneumonitis' },
  { id: '3', display: 'Pulmonary fibrosis' },
  { id: '4', display: 'Pulmonary dysfunction' },
  { id: '5', display: 'Acute respiratory distress syndrome (ARDS)' },
  { id: '6', display: 'Obstructive lung disease' },
  { id: '7', display: 'Restrictive lung disease' },
  { id: '8', display: 'Chronic bronchitis' },
  { id: '9', display: 'Bronchiectasis' },
  { id: '10', display: 'Other' },
  { id: '11', display: 'Not applicable' },
  { id: '12', display: 'Don\'t Remember' },
];

export const stomachProblemsOptions = [
  { id: '1', display: 'Pain' },
  { id: '2', display: 'Tenderness' },
  { id: '3', display: 'Constipation' },
  { id: '4', display: 'Diarrhea' },
  { id: '5', display: 'Bleeding from the bowel' },
  { id: '6', display: 'Other' },
  { id: '7', display: 'Not applicable' },
  { id: '8', display: 'Don\'t Remember' },
];

export const gastrointestinalProblemsOptions = [
  { id: '1', display: 'Abdominal adhesion' },
  { id: '2', display: 'Bowel obstruction' },
  { id: '3', display: 'Bowel strictures' },
  { id: '4', display: 'Fecal incontinence' },
  { id: '5', display: 'Cholelithiasis' },
  { id: '6', display: 'Cholecystitis' },
  { id: '7', display: 'Chronic enterocolitis' },
  { id: '8', display: 'Esophageal stricture' },
  { id: '9', display: 'Fistula' },
  { id: '10', display: 'Malabsorption' },
  { id: '11', display: 'Nutritional deficiency' },
  { id: '12', display: 'Vitamin B12, folate or carotene deficiency' },
  { id: '13', display: 'Cirrhosis' },
  { id: '14', display: 'Hepatic fibrosis' },
  { id: '15', display: 'Hepatic dysfunction' },
  { id: '16', display: 'Chronic hepatitis (non-infectious)' },
  { id: '17', display: 'Iron overload' },
  { id: '18', display: 'Venocclusive disease (VOD) of the liver' },
  { id: '19', display: 'Other' },
  { id: '20', display: 'Not applicable' },
  { id: '21', display: 'Don\'t Remember' },
];

export const brokenFracturedBonesOptions = [
  { id: '1', display: 'Broken' },
  { id: '2', display: 'Fractured' },
  { id: '3', display: 'Don\'t Remember' },
];

export const musculoskeletalProblemsOptions = [
  { id: '1', display: 'Scoliosis' },
  { id: '2', display: 'Reduced/uneven growth' },
  { id: '3', display: 'Osteonecrosis (avascular necrosis – AVN)' },
  { id: '4', display: 'Amputation' },
  { id: '5', display: 'Craniofacial abnormalities' },
  { id: '6', display: 'Impaired cosmesis' },
  { id: '7', display: 'Contractures' },
  { id: '8', display: 'Functional and activity limitation' },
  { id: '9', display: 'Hypoplasia' },
  { id: '10', display: 'Kyphosis' },
  { id: '11', display: 'Limb length discrepancy' },
  { id: '12', display: 'Limb salvage' },
  { id: '13', display: 'Phantom pain' },
  { id: '14', display: 'Prosthesis, malfunction (poor fit, loosening, non-union, fracture)' },
  { id: '15', display: 'Prosthesis, revision required due to growth' },
  { id: '16', display: 'Reduced bone mineral density' },
  { id: '17', display: 'Residual limb integrity problems' },
  { id: '18', display: 'Increased energy expenditure (related to amputation/limb salvage)' },
  { id: '19', display: 'Fibrosis (musculoskeletal)' },
  { id: '20', display: 'Short stature' },
  { id: '21', display: 'Shortened trunk height' },
  { id: '22', display: 'Other' },
  { id: '23', display: 'Not applicable' },
  { id: '24', display: 'Don\'t Remember' },
];

export const cnsDiagnosedProblemsOptions = [
  { id: '1', display: 'Fitting (epilepsy)' },
  { id: '2', display: 'Dizziness/migraine' },
  { id: '3', display: 'Problems with your balance' },
  { id: '4', display: 'Squint' },
  { id: '5', display: 'Problems with swallowing' },
  { id: '6', display: 'Do you have to drink water to help you eat' },
  { id: '7', display: 'Prescribed growth hormone' },
  { id: '8', display: 'Other' },
  { id: '9', display: 'Not applicable' },
  { id: '10', display: 'Don\'t Remember' },
];

export const cnsOtherProblemsOptions = [
  { id: '1', display: 'Clinical leukoencephalopathy' },
  { id: '2', display: 'With imaging abnormalities' },
  { id: '3', display: 'Without imaging abnormalities' },
  { id: '4', display: 'Learning disorder/disability (math, reading, other)' },
  { id: '5', display: 'Motor deficit' },
  { id: '6', display: 'Neurocognitive deficit' },
  { id: '7', display: 'Diminished IQ' },
  { id: '8', display: 'Executive function (planning/organization)' },
  { id: '9', display: 'Sustained attention' },
  { id: '10', display: 'Memory' },
  { id: '11', display: 'Processing speed' },
  { id: '12', display: 'Visual-motor integration' },
  { id: '13', display: 'Fine motor dexterity' },
  { id: '14', display: 'Language' },
  { id: '15', display: 'Moyamoya' },
  { id: '16', display: 'Cavernomas' },
  { id: '17', display: 'Ataxia' },
  { id: '18', display: 'Movement disorder' },
  { id: '19', display: 'Neurogenic bladder' },
  { id: '20', display: 'Neurogenic bowel' },
  { id: '21', display: 'Paralysis' },
  { id: '22', display: 'Occlusive cerebral vasculopathy' },
  { id: '23', display: 'Seizures' },
  { id: '24', display: 'Stroke' },
  { id: '25', display: 'Other' },
  { id: '26', display: 'Not applicable' },
  { id: '27', display: 'Don\'t Remember' },
];

export const dermatologicProblemsOptions = [
  { id: '1', display: 'Alopecia (permanent)' },
  { id: '2', display: 'Dysplastic nevi' },
  { id: '3', display: 'Altered skin pigmentation' },
  { id: '4', display: 'Skin fibrosis' },
  { id: '5', display: 'Nail dysplasia' },
  { id: '6', display: 'Scleroderma' },
  { id: '7', display: 'Telangiectasia' },
  { id: '8', display: 'Other' },
  { id: '9', display: 'Not applicable' },
  { id: '10', display: 'Don\'t Remember' },
];

export const immuneProblemsOptions = [
  { id: '1', display: 'Asplenia' },
  { id: '2', display: 'Chronic sinusitis' },
  { id: '3', display: 'Chronic graft versus host disease (GVHD)' },
  { id: '4', display: 'Chronic Hepatitis B' },
  { id: '5', display: 'Chronic Hepatitis C' },
  { id: '6', display: 'Chronic infection' },
  { id: '7', display: 'Human immunodeficiency virus (HIV) infection' },
  { id: '8', display: 'Hypogammablobulinemia' },
  { id: '9', display: 'Secretory IgA deficiency' },
  { id: '10', display: 'Other' },
  { id: '11', display: 'Not applicable' },
  { id: '12', display: 'Don\'t Remember' },
];

export const aspleniaOptions = [
  { id: '1', display: 'Functional asplenia' },
  { id: '2', display: 'Surgical asplenia' },
  { id: '3', display: 'History of life-threatening infection related to asplenia' },
];

export const painChronicProblemsOptions = [
  { id: '1', display: 'Musculoskeletal' },
  { id: '2', display: 'Neuropathic' },
  { id: '3', display: 'Other' },
  { id: '4', display: 'Not applicable' },
  { id: '5', display: 'Don\'t Remember' },
];

export const patientMaritalStatusOptions = [
  {
    id: '1',
    code: 'A',
    display: 'Annulled',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
  },
  {
    id: '2',
    code: 'D',
    display: 'Divorced',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
  },
  {
    id: '3',
    code: 'I',
    display: 'Interlocutory',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
  },
  {
    id: '4',
    code: 'L',
    display: 'Legally separated',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
  },
  {
    id: '5',
    code: 'M',
    display: 'Married',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
  },
  {
    id: '6',
    code: 'P',
    display: 'Polygamous',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
  },
  {
    id: '7',
    code: 'S',
    display: 'Never married',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
  },
  {
    id: '8',
    code: 'T',
    display: 'Domestic partner',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
  },
  {
    id: '9',
    code: 'U',
    display: 'Unmarried',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
  },
  {
    id: '10',
    code: 'W',
    display: 'Widowed',
    system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
  },
  {
    id: '11',
    code: 'UNK',
    display: 'Unknown',
    system: 'http://terminology.hl7.org/CodeSystem/v3-NullFlavor',
  },
];

export const australianStateOptions = [
  {
    id: '1',
    display: 'NSW',
  },
  {
    id: '2',
    display: 'VIC',
  },
  {
    id: '3',
    display: 'QLD',
  },
  {
    id: '4',
    display: 'SA',
  },
  {
    id: '5',
    display: 'TAS',
  },
  {
    id: '6',
    display: 'WA',
  },
  {
    id: '7',
    display: 'ACT',
  }
];

export const contactRelationshipOptions = [
  {
    id: '1',
    code: 'C',
    display: 'Emergency Contact',
  },
  {
    id: '2',
    code: 'E',
    display: 'Employer',
  },
  {
    id: '3',
    code: 'F',
    display: 'Federal Agency',
  },
  {
    id: '4',
    code: 'I',
    display: 'Insurance Company',
  },
  {
    id: '5',
    code: 'N',
    display: 'Next-of-Kin',
  },
  {
    id: '6',
    code: 'S',
    display: 'State Agency',
  },
  {
    id: '7',
    code: 'U',
    display: 'Unknown',
  },

];

export const newPatientObj = {
  resourceType: 'Patient',
  active: true,
  name: [
    {
      use: 'official',
      family: '',
      given: [
        '',
      ],
    },
  ],
  gender: '',
  birthDate: '',
  address: [{
    use: 'home',
    type: 'both',
    postalCode: '0',
    line: ['', ''],
    city: '',
    state: '',
  }],
  maritalStatus: {
    coding: [
      {
        system: 'http://terminology.hl7.org/CodeSystem/v3-MaritalStatus',
        code: '',
        display: '',
      },
    ],
  },
  telecom: [
    {
      system: 'email',
      value: '0',
      use: 'home',
    },
    {
      system: 'phone',
      value: '',
      use: 'home',
    },
    {
      system: 'phone',
      value: '',
      use: 'mobile',
    },
  ],
  contact: [{
    name:
          {
            use: 'official',
            family: '0',
            given: [
              '0',
            ],
          },
    telecom: [
      {
        system: 'phone',
        value: '0',
        use: 'mobile',
      },
    ],
    gender: 'male',
    relationship: {
      text: '',
    },
  }],
  generalPractitioner: [
    {
      display: '',
    },
  ],
};




// WEBPACK FOOTER //
// ./src/components/AnswerArray.js